import React, { Component } from 'react';
import cx from 'classnames';
import ReactCountryFlag from 'react-country-flag';
import { connect } from 'react-redux';
import { Select } from 'antd';

import Dropdown from './antdDropdown';
import { languagesWithEnglish } from '../../data/languages';
import { getMaxLanguageWidth } from '../utils/language.utils';
import { shouldRenderMobile } from '../../utils/platform';
import { changeLanguage } from '../../store/actions/responses';
import { Features, isFeatureEnabled } from '../../featureToggles/features';
import { DEFAULT_LOCALE_CODE, localesLangList } from '../../data/locales';

import styles from './languageChanger.module.scss';

const isPanelEnv = isFeatureEnabled(Features.panel);

class LanguageChanger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableLanguages: this.getAvailableLanguages(),
    };
    this.dropdown = React.createRef();
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
  }

  componentDidMount() {
    const dropdown = document.getElementsByClassName(styles.dropdown);
    if (dropdown.length) {
      const { availableLanguages } = this.state;
      const width = getMaxLanguageWidth(availableLanguages);
      dropdown[0].setAttribute('style', `width: ${width}px`);
    }
  }

  getAvailableLanguages() {
    const { defaultLanguage, languages = [] } = this.props;
    const availableLanguages = [];
    const registeredLanguages = [defaultLanguage, ...languages];
    const languagesList = isFeatureEnabled(Features.panel) ? localesLangList : languagesWithEnglish;
    languagesList.forEach((item) => {
      if (registeredLanguages.includes(item.key)) {
        availableLanguages.push(item);
      }
    });
    return availableLanguages;
  }

  onChangeLanguage(_, language) {
    this.props.changeLanguage({
      selectedLanguage: language.value,
    });
    if (window.parent) {
      window.parent.postMessage({ event: 'changeLanguage', message: language.key }, '*');
    }
  }

  renderLanguageItems() {
    const { availableLanguages } = this.state;
    const flagStyle = {
      marginRight: '15px',
      fontSize: '20px',
      height: '15px',
      width: '20px',
      marginTop: '-2px',
    };
    if (isPanelEnv) {
      return availableLanguages.map((lang) => {
        return (
          <Select.Option key={lang.key} value={lang.value} language={lang.googleLanguageCode}>
            <ReactCountryFlag countryCode={lang.flag} svg style={flagStyle} />
            <span>{lang.text}</span>
          </Select.Option>
        );
      });
    }
    return availableLanguages.map((lang) => {
      return (
        <Select.Option key={lang.key} onClick={this.onChangeLanguage.bind(this, lang.key)}>
          <ReactCountryFlag countryCode={lang.flag} svg style={flagStyle} />
          <span>{lang.text}</span>
        </Select.Option>
      );
    });
  }

  render() {
    const { hideLanguageChanger, languages, selectedLanguage } = this.props;
    if (languages.length === 0 || hideLanguageChanger) {
      return null;
    }
    return (
      <div className={cx(styles.languageChangerContainer, { [styles.mobile]: shouldRenderMobile() })}>
        <Dropdown
          onChange={this.onChangeLanguage}
          className={cx(styles.dropdown, { [styles.dropdownForPanel2]: isFeatureEnabled(Features.panel2) })}
          value={selectedLanguage}
        >
          {this.renderLanguageItems()}
        </Dropdown>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    customization: { defaultLanguage: projectLanguage = 'en', defaultLocale = DEFAULT_LOCALE_CODE },
    activeProject: { survey: { isTranslationEnabled } = {} } = {},
    capture: { selectedLanguage: captureLanguage, availableLanguages = [] } = {},
    visualizationTypes = {},
  } = state;

  const selectedLanguage = captureLanguage || (isFeatureEnabled(Features.panel) ? DEFAULT_LOCALE_CODE : 'en');
  const defaultLanguage = isFeatureEnabled(Features.panel) ? defaultLocale : projectLanguage;
  return {
    languages: availableLanguages,
    selectedLanguage,
    defaultLanguage,
    isTranslationEnabled,
    hideLanguageChanger: visualizationTypes.isViewAnswers,
  };
};

export default connect(mapStateToProps, { changeLanguage })(LanguageChanger);

export { LanguageChanger };
